/* global gtmDosageformDropdownToggle */

class ProductBoxGallerySwipe {
  constructor(productBox) {
    this.productBox = productBox;
    this.swipeStartX = 0;
    this.swipeStartY = 0;
    this.swipeEndX = 0;
    this.swipeEndY = 0;
    this.multiTouch = false;
    this.productBox.addEventListener('touchstart', (e) => {
      if (e.touches.length === 1) {
        this.swipeStartX = e.changedTouches[0].screenX;
        this.swipeStartY = e.changedTouches[0].screenY;
        this.multiTouch = false;
      } else {
        this.multiTouch = true;
      }
    });
    this.productBox.addEventListener('touchend', (e) => {
      if (!e.target.closest('ul.product-box-gallery')) {
        this.swipeEndX = e.changedTouches[0].screenX;
        this.swipeEndY = e.changedTouches[0].screenY;
        this.handleSwipe();
      }
    });
  }
  handleSwipe() {
    if (zoomed || this.multiTouch) return;
    const threshold = 50;
    const deltaX = this.swipeEndX - this.swipeStartX;
    const deltaY = this.swipeEndY - this.swipeStartY;
    if (Math.abs(deltaY) > Math.abs(deltaX)) {
      if (Math.abs(deltaY) > threshold && productBoxExpanded) {
        const currentVisual = document.querySelector('#product-box-gallery-visuals .product-box-gallery-visual:not(.invisible)');
        if (currentVisual) currentVisual.classList.add('returning');
        toggleBoxZoom();
      }
    } else {
      if (deltaX < -threshold) changeGalleryImage('next');
      if (deltaX > threshold) changeGalleryImage('prev');
    }
  }
}


const ctaButton = document.querySelector('.product-cta-button');
if (ctaButton) {
  window.onscroll = function () {
    ctaButton.classList.toggle('product-cta-button--fixed', Math.floor(window.scrollY) - 70 >= Math.floor(ctaButton.offsetTop));
  };
}

if (typeof gtmDosageformDropdownToggle === 'function') {
  document
    .querySelectorAll('.dosage-forms .accordion-button')
    .forEach((element) => element.addEventListener('click', gtmDosageformDropdownToggle));
}

// ── Product box zoom / gallery ────────────────────────────────────────────────

let productBoxExpanded = false;
let zoomed = false;
let dragging = false;
let hasMoved = false;
let startX, startY;
let dragStartX = 0, dragStartY = 0;
let translateX = 0;
let translateY = 0;
const DRAG_THRESHOLD = 5;
let dragController = null;
let showingDosageFormPackshot = false;
let lastTapTime = 0;
let lastTapTarget = null;
let currentScale = 1;
let pinchActive = false;
let pinchStartDist = 0;
let pinchLastDist = 0;
let pinchStartScale = 1;
let pinchHolderNatLeft = 0;
let pinchHolderNatTop = 0;
let prevPinchMidX = 0;
let prevPinchMidY = 0;
const isTouchDevice = () => window.matchMedia('(pointer: coarse)').matches;
const zoomTargetSize = () => window.innerWidth < 768 ? 1290 : 2048;

function handleDoubleTap(target, callback) {
  const now = Date.now();
  if (now - lastTapTime < 300 && lastTapTarget === target) {
    lastTapTime = 0;
    lastTapTarget = null;
    callback();
  } else {
    lastTapTime = now;
    lastTapTarget = target;
  }
}

function changeGalleryImage(direction) {
  const galleryButtons = document.querySelectorAll('#product-box .product-box-gallery li:not([hidden]) button');
  if (!galleryButtons.length) return;
  const currentIndex = [...galleryButtons].findIndex(btn => btn.classList.contains('active'));
  const next = direction === 'next'
    ? (currentIndex + 1) % galleryButtons.length
    : (currentIndex - 1 + galleryButtons.length) % galleryButtons.length;
  galleryButtons[next].click();
}

function rotateBox() {
  const boxSides = document.querySelectorAll('.box-side-selector');
  const currentSide = [...boxSides].findIndex(r => r.checked);
  boxSides[(currentSide + 1) % boxSides.length].checked = true;
}

function show3DFaceOverlay(boxSide, event, zoom = true) {
  const overlay = document.getElementById('product-box-3d-face-visual');
  if (!overlay) return;
  const img = overlay.querySelector('img');
  img.src = boxSide.dataset.src;
  overlay.classList.remove('invisible', 'opacity-0');
  if (zoom) {
    const doZoom = () => {
      const rect = img.getBoundingClientRect();
      zoomInVisual({
        clientX: event?.clientX ?? rect.left + rect.width / 2,
        clientY: event?.clientY ?? rect.top + rect.height / 2,
        preventDefault: () => {},
        stopPropagation: () => {},
      }, img);
    };
    img.complete && img.naturalWidth > 0 ? doZoom() : img.addEventListener('load', doZoom, { once: true });
  }
}

function hide3DFaceOverlay() {
  const overlay = document.getElementById('product-box-3d-face-visual');
  if (!overlay) return;
  overlay.classList.add('invisible', 'opacity-0');
}

function toggleBoxZoom() {
  document.getElementById('product-box').classList.toggle('expanded');
  document.querySelector('body').classList.toggle('overflow-hidden');
  productBoxExpanded = !productBoxExpanded;
  document.getElementById('product-box').ariaModal = productBoxExpanded;
  const boxZoomBtn = document.getElementById('product-box-controls-box-zoom');
  if (boxZoomBtn) boxZoomBtn.ariaExpanded = productBoxExpanded;
  document[productBoxExpanded ? 'addEventListener' : 'removeEventListener']('keydown', handleKeydown);
  dragController?.abort();
  dragController = null;
  document.querySelectorAll('#product-box img.zoomed').forEach((img) => {
    img.removeAttribute('style');
    img.classList.remove('zoomed', 'dragging', 'pinching');
    img.parentElement.removeAttribute('style');
  });
  zoomed = dragging = hasMoved = pinchActive = false;
  translateX = translateY = 0;
  currentScale = 1;
  lastTapTime = 0;
  lastTapTarget = null;
  hide3DFaceOverlay();
  if (document.getElementById('box-zoom-toggle').checked) { toggleVisualZoom(); }
}

function handleKeydown(e) {
  if (e.key === 'Escape') {
    if (zoomed) {
      hasMoved = false;
      zoomInVisual({ clientX: 0, clientY: 0, preventDefault: () => {}, stopPropagation: () => {} }, document.querySelector('#product-box img.zoomed'));
      hide3DFaceOverlay();
    } else if (document.getElementById('box-zoom-toggle').checked) {
      toggleVisualZoom();
    } else {
      toggleBoxZoom();
    }
  }
  if (e.key === 'Tab') {
    if (!e.shiftKey && document.activeElement.id == 'product-box-controls-next') {
      e.preventDefault();
      if (document.getElementById('product-box-controls-rotate').hidden) {
        document.getElementById('product-box-controls-visual-zoom').focus();
      } else {
        document.getElementById('product-box-controls-rotate').focus();
      }
    }
    if (e.shiftKey) {
      if (
        document.activeElement.id == 'product-box-controls-rotate' ||
        (
          document.activeElement.id == 'product-box-controls-visual-zoom' &&
          document.getElementById('product-box-controls-rotate').hidden
        )
      ) {
        e.preventDefault();
        document.getElementById('product-box-controls-next').focus();
      }
    }
  }
}

function toggleVisualZoom() {
  const showingZoomableGalleryImage = document.querySelector('#product-box.expanded #product-box-gallery-visuals .product-box-gallery-visual:not(.invisible) img');
  const showingZoomableDosageformPackshot = document.querySelector('#product-box.expanded #product-dosageforms-packshots .product-dosageforms-packshot:not([hidden]) img');
  const faceOverlay = document.getElementById('product-box-3d-face-visual');
  const showingFaceOverlayImg = faceOverlay && !faceOverlay.classList.contains('invisible') ? faceOverlay.querySelector('img') : null;
  const zoomableImage = showingZoomableGalleryImage || showingZoomableDosageformPackshot || showingFaceOverlayImg || false;

  if (zoomableImage) {
    hasMoved = false;
    const rect = zoomableImage.getBoundingClientRect();
    zoomInVisual({
      clientX: rect.left + rect.width / 2,
      clientY: rect.top + rect.height / 2,
      preventDefault: () => {},
      stopPropagation: () => {},
    }, zoomableImage);
    if (!zoomed && showingFaceOverlayImg) hide3DFaceOverlay();
  } else {
    const checkedSideInput = document.querySelector('#product-box.expanded #product-box-default:not([hidden]) input.box-side-selector:checked');
    if (faceOverlay && checkedSideInput) {
      const boxSide = document.querySelector(`#product-box-default .box-side[data-side="${checkedSideInput.dataset.side}"][data-src], #product-box-default .box-side-2d[data-side="${checkedSideInput.dataset.side}"][data-src]`);
      if (boxSide) { show3DFaceOverlay(boxSide, null); return; }
    }
    document.getElementById('box-zoom-toggle').click();
  }
}

function handleVisualZoomToggle(checkbox) {
  document.getElementById('product-box-controls-visual-zoom').ariaExpanded = checkbox.checked;
  document.getElementById('product-box').classList.toggle('visual-zoom', checkbox.checked);
}

function exitZoomedState(img, imgHolder) {
  dragController?.abort();
  dragController = null;
  img.style.transform = '';
  img.classList.remove('zoomed', 'dragging', 'pinching');
  imgHolder.style.transform = '';
  translateX = translateY = 0;
  dragging = hasMoved = pinchActive = false;
  currentScale = 1;
}

function attachZoomedListeners(img, imgHolder, signal) {
  img.addEventListener('pointerdown', (el) => {
    if (!zoomed || pinchActive) return;
    dragging = true;
    hasMoved = false;
    startX = el.clientX - translateX;
    startY = el.clientY - translateY;
    dragStartX = el.clientX;
    dragStartY = el.clientY;
    img.classList.add('dragging');
  }, { signal });
  img.addEventListener('pointermove', (el) => {
    if (!dragging) return;
    translateX = el.clientX - startX;
    translateY = el.clientY - startY;
    if (Math.abs(el.clientX - dragStartX) > DRAG_THRESHOLD || Math.abs(el.clientY - dragStartY) > DRAG_THRESHOLD) {
      if (!hasMoved) img.setPointerCapture(el.pointerId);
      imgHolder.style.transform = `translate(${translateX}px, ${translateY}px)`;
      hasMoved = true;
    }
  }, { signal });
  img.addEventListener('pointerup', (el) => {
    dragging = false;
    img.classList.remove('dragging');
    img.releasePointerCapture(el.pointerId);
  }, { signal });
  img.addEventListener('pointercancel', () => {
    dragging = false;
    img.classList.remove('dragging');
  }, { signal });
  img.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 2) return;
    e.preventDefault();
    pinchActive = true;
    dragging = false;
    img.classList.remove('dragging');
    img.classList.add('pinching');
    const t0 = e.touches[0], t1 = e.touches[1];
    const midX = (t0.clientX + t1.clientX) / 2;
    const midY = (t0.clientY + t1.clientY) / 2;
    pinchStartDist = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
    pinchLastDist = pinchStartDist;
    pinchStartScale = currentScale;
    prevPinchMidX = midX;
    prevPinchMidY = midY;
    const holderRect = imgHolder.getBoundingClientRect();
    pinchHolderNatLeft = holderRect.left - translateX;
    pinchHolderNatTop = holderRect.top - translateY;
    if (currentScale !== 1 && img.style.transformOrigin) {
      const [oxStr, oyStr] = img.style.transformOrigin.split(' ');
      const ox = parseFloat(oxStr) / 100;
      const oy = parseFloat(oyStr) / 100;
      const effTx = translateX + ox * img.offsetWidth * (1 - currentScale);
      const effTy = translateY + oy * img.offsetHeight * (1 - currentScale);
      translateX = (effTx - (midX - pinchHolderNatLeft) * (1 - currentScale)) / currentScale;
      translateY = (effTy - (midY - pinchHolderNatTop) * (1 - currentScale)) / currentScale;
      const newOx = (midX - pinchHolderNatLeft - translateX) / img.offsetWidth;
      const newOy = (midY - pinchHolderNatTop - translateY) / img.offsetHeight;
      img.style.transformOrigin = `${newOx * 100}% ${newOy * 100}%`;
      imgHolder.style.transform = `translate(${translateX}px, ${translateY}px)`;
    }
  }, { signal, passive: false });
  img.addEventListener('touchmove', (e) => {
    if (!pinchActive || e.touches.length !== 2) return;
    e.preventDefault();
    const t0 = e.touches[0], t1 = e.touches[1];
    const dist = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
    const midX = (t0.clientX + t1.clientX) / 2;
    const midY = (t0.clientY + t1.clientY) / 2;
    const newScale = Math.min(zoomTargetSize() / img.offsetWidth, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
    pinchLastDist = dist;
    translateX += midX - prevPinchMidX;
    translateY += midY - prevPinchMidY;
    prevPinchMidX = midX;
    prevPinchMidY = midY;
    const localX = midX - pinchHolderNatLeft - translateX;
    const localY = midY - pinchHolderNatTop - translateY;
    img.style.transformOrigin = `${(localX / img.offsetWidth) * 100}% ${(localY / img.offsetHeight) * 100}%`;
    img.style.transform = `scale(${newScale})`;
    imgHolder.style.transform = `translate(${translateX}px, ${translateY}px)`;
    currentScale = newScale;
    hasMoved = true;
  }, { signal, passive: false });
  img.addEventListener('touchend', (e) => {
    if (e.touches.length < 2 && pinchActive) {
      e.stopPropagation();
      pinchActive = false;
      img.classList.remove('pinching');
      hasMoved = true;
      if (currentScale <= 1) {
        exitZoomedState(img, imgHolder);
        zoomed = false;
        if (img.closest('#product-box-3d-face-visual')) hide3DFaceOverlay();
        if (pinchStartScale === 1 && pinchLastDist < pinchStartDist * 0.8) toggleBoxZoom();
      }
      return;
    }
    if (pinchActive) return;
    if (e.changedTouches.length !== 1 || hasMoved) { if (hasMoved) e.stopPropagation(); return; }
    const now = Date.now();
    if (now - lastTapTime < 300 && lastTapTarget === img) {
      e.preventDefault();
      lastTapTime = 0;
      lastTapTarget = null;
      hasMoved = false;
      const touch = e.changedTouches[0];
      zoomInVisual({ clientX: touch.clientX, clientY: touch.clientY, preventDefault: () => {}, stopPropagation: () => {} }, img);
      if (!zoomed && img.closest('#product-box-3d-face-visual')) hide3DFaceOverlay();
    } else {
      e.preventDefault();
      lastTapTime = now;
      lastTapTarget = img;
    }
  }, { signal });
  img.addEventListener('touchcancel', () => {
    if (pinchActive) { pinchActive = false; img.classList.remove('pinching'); hasMoved = true; }
  }, { signal });
}

function zoomInVisual(event, img) {
  const imgHolder = img.parentElement;

  if (hasMoved) {
    event.preventDefault();
    event.stopPropagation();
    return;
  }

  const rect = img.getBoundingClientRect();
  const originX = ((event.clientX - rect.left) / rect.width) * 100;
  const originY = ((event.clientY - rect.top) / rect.height) * 100;

  if (!zoomed) {
    img.style.transformOrigin = `${originX}% ${originY}%`;
    currentScale = zoomTargetSize() / rect.width;
    img.style.transform = `scale(${currentScale})`;
    img.classList.add('zoomed');
    dragController = new AbortController();
    attachZoomedListeners(img, imgHolder, dragController.signal);
  } else {
    exitZoomedState(img, imgHolder);
  }

  zoomed = !zoomed;
}

function handleProductVariantChange(e) {
  const productPackshot = e.options[e.selectedIndex].dataset.packshot;
  const targetPackshot = document.getElementById(productPackshot);

  document.querySelectorAll('#product-dosageforms-packshots > .product-dosageforms-packshot').forEach((packshot) => {
    packshot.hidden = true;
  });
  // Show the pack-size packshot for any non-default size (existing behaviour),
  // AND for the default size when that pack size has its own image (ORT-3072).
  if (e.selectedIndex > 0 || targetPackshot?.dataset.hasOwnPackshot === '1') {
    document.getElementById('product-box-default').hidden = true;
    targetPackshot.hidden = false;
    showingDosageFormPackshot = true;
  } else {
    document.getElementById('product-box-default').hidden = false;
    showingDosageFormPackshot = false;
  }

  const selectedOption = e.options[e.selectedIndex];
  const url = new URL(window.location.href);
  const paramMap = {
    form: selectedOption.dataset.urlForm,
    flavor: selectedOption.dataset.urlFlavor,
    size: selectedOption.dataset.urlSize,
  };
  // Address-bar URL: write the raw (un-slugged) pack size so a space serialises as
  // "+" (the long-standing notation) instead of "-", and server-side variant
  // preselection keeps matching. The slugged paramMap.size is still used for
  // gallery-image matching in updateDosageFormSelection() below.
  const urlParamMap = { ...paramMap, size: selectedOption.dataset.urlSizeRaw || paramMap.size };
  for (const [key, value] of Object.entries(urlParamMap)) {
    if (value) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }
  }

  const currentDefaultImage = document.querySelector('#product-dosageforms-packshots .product-dosageforms-packshot:not([hidden]) img');
  const originalButton = document.querySelector('#product-box .product-box-gallery > li:first-child > button img');
  if (originalButton) {
    if (currentDefaultImage) {
      originalButton.src = currentDefaultImage.src;
    } else { // 2d or 3d packshot are shown
      const defaultBoxSide = document.querySelector(
        '#product-box-default .box-side[data-side="front"][data-src], #product-box-default .box-side-2d[data-side="front"][data-src]'
      );
      if (defaultBoxSide) originalButton.src = defaultBoxSide.dataset.src;
    }
  }

  history.replaceState(null, '', url.toString());
  updateDosageFormSelection(paramMap.form, paramMap.flavor, paramMap.size);
}

function updateDosageFormSelection(form, flavor, size) {
  const selectionsList = document.querySelector('.dosage-forms .list-component-categories');
  const selectionInput = selectionsList?.querySelector(`input[data-form="${form}"][data-flavor="${flavor}"]`);
  const selectionLabel = selectionsList?.querySelector(`input[data-form="${form}"][data-flavor="${flavor}"] + label`);

  if (selectionsList && selectionInput && selectionLabel) {
    selectionInput.click();
    selectionsList.scrollLeft = selectionLabel.offsetLeft - (selectionsList.clientWidth - selectionLabel.clientWidth) / 2;
  }

  const galleryButtons = document.querySelectorAll('#product-box .product-box-gallery > li:not(:first-child) > button');
  let totalCount = 1;
  galleryButtons.forEach((button) => {
    const fullName = form + (flavor ? '-' + flavor : '') + (size ? '-' + size : '');
    button.parentNode.hidden = button.dataset.galleryImageDosageForm !== fullName;
    totalCount += button.parentNode.hidden ? 0 : 1;
  });
  document.getElementById('product-box-controls-index-total').innerText = totalCount;
  document.getElementById('product-box-controls-rotate').hidden = showingDosageFormPackshot || document.querySelectorAll('#product-box-default .product-packshot .box-side-2d').length == 1;
  document.querySelector('#product-box .product-box-gallery-arrows').hidden = totalCount == 1;
  document.querySelector('#product-box .product-box-gallery > li:first-child > button')?.click();
}

function showGalleryImage(dosageForm, imageToShow) {
  const productBadge = document.querySelector('#product-box > .badge');
  if (imageToShow > 0) {
    if (showingDosageFormPackshot) {
      document.querySelector('#product-dosageforms-packshots').classList.remove('d-flex');
      document.querySelector('#product-dosageforms-packshots').hidden = true;
    } else {
      document.querySelector('#product-box-default').hidden = true;
    }
    document.querySelectorAll('#product-box-gallery-visuals .product-box-gallery-visual').forEach((visual) => {
      if (visual.dataset.galleryImageDosageForm == dosageForm && visual.dataset.galleryImageNr == imageToShow) {
        visual.classList.remove('invisible', 'position-absolute', 'top-0');
        document.querySelector('.product-box-gallery-visual.returning')?.classList.remove('returning');
      } else {
        visual.classList.add('invisible', 'position-absolute', 'top-0');
      }
    });
    document.getElementById('product-box-controls-rotate').hidden = true;
    if (productBadge) productBadge.hidden = true;
  } else {
    document.querySelectorAll('#product-box-gallery-visuals .product-box-gallery-visual').forEach((visual) => {
      visual.classList.add('invisible', 'position-absolute', 'top-0');
    });
    document.querySelector('.product-box-gallery-visual.returning')?.classList.remove('returning');
    if (showingDosageFormPackshot) {
      document.querySelector('#product-dosageforms-packshots').hidden = false;
      document.querySelector('#product-dosageforms-packshots').classList.add('d-flex');
    } else {
      document.querySelector('#product-box-default').hidden = false;
    }
    document.getElementById('product-box-controls-rotate').hidden = showingDosageFormPackshot || document.querySelectorAll('#product-box-default .product-packshot .box-side-2d').length == 1;
    if (productBadge) productBadge.hidden = false;
  }
  if (document.getElementById('box-zoom-toggle').checked) { toggleVisualZoom(); }
  document.getElementById('product-box-controls-index-count').innerText = imageToShow + 1;
}

document.addEventListener('DOMContentLoaded', function () {
  const productBox = document.getElementById('product-box');
  if (!productBox) return;

  document.getElementById('product-box-controls-rotate')?.addEventListener('click', rotateBox);
  document.getElementById('product-box-controls-visual-zoom')?.addEventListener('click', toggleVisualZoom);
  document.getElementById('product-box-controls-box-zoom')?.addEventListener('click', toggleBoxZoom);
  document.querySelectorAll('.box-zoom-toggle').forEach((cb) => cb.addEventListener('change', (e) => handleVisualZoomToggle(e.target)));

  const selectElement = document.getElementById('product-variant-select');
  if (selectElement) {
    selectElement.disabled = false;
    selectElement.addEventListener('change', (e) => handleProductVariantChange(e.target));
    handleProductVariantChange(selectElement);
  }

  document.querySelector('.product-box-gallery')?.addEventListener('click', function (e) {
    const button = e.target.closest('button');
    if (button) {
      e.stopPropagation();
      const holder = button.closest('ul');
      const galleryImageDosageForm = button.dataset.galleryImageDosageForm;
      const galleryImageNr = Number.parseInt(button.dataset.galleryImageNr, 10) || 0;
      document.querySelector('.product-box-gallery button.active')?.classList.remove('active');
      button.classList.add('active');
      holder.scrollTo({ left: button.offsetLeft + (button.offsetWidth - holder.offsetWidth) / 2, behavior: 'smooth' });
      showGalleryImage(galleryImageDosageForm, galleryImageNr);
    }
  });

  productBox.addEventListener('click', function (e) {
    const isZoomed = productBox.classList.contains('expanded');
    if (e.target.closest('#product-box-default')) {
      if (!isZoomed) {
        toggleBoxZoom();
      } else if (e.target.closest('.box-side[data-src], .box-side-2d[data-src]')) {
        const boxSide = e.target.closest('.box-side[data-src], .box-side-2d[data-src]');
        if (isTouchDevice()) {
          handleDoubleTap(boxSide, () => show3DFaceOverlay(boxSide, e));
        } else {
          show3DFaceOverlay(boxSide, e);
        }
      } else if (!e.target.closest('.box-controls')) {
        toggleBoxZoom();
      }
    }
    if (e.target.closest('img') && !e.target.closest('#product-box-default')) {
      if (!isZoomed) {
        toggleBoxZoom();
      } else {
        const img = e.target.closest('img');
        if (isTouchDevice()) {
          handleDoubleTap(img, () => {
            e.preventDefault();
            hasMoved = false;
            zoomInVisual(e, img);
            if (!zoomed && img.closest('#product-box-3d-face-visual')) hide3DFaceOverlay();
          });
        } else {
          zoomInVisual(e, e.target);
          if (!zoomed && e.target.closest('#product-box-3d-face-visual')) hide3DFaceOverlay();
        }
      }
    }
    if (isZoomed &&
      !e.target.closest('img') &&
      !e.target.closest('#product-box-default') &&
      !e.target.closest('.product-box-controls') &&
      !e.target.closest('.product-box-gallery')) {
      toggleBoxZoom();
    }
  });

  document.querySelector('.product-box-gallery-arrows')?.addEventListener('click', function (e) {
    if (e.target.matches('button')) {
      changeGalleryImage(e.target.dataset.direction);
    }
  });

  productBox.addEventListener('touchstart', (e) => {
    if (e.touches.length !== 2) return;
    if (!productBox.classList.contains('expanded')) {
      if (!e.target.closest('img, .box-side[data-src], .box-side-2d[data-src]')) return;
      e.preventDefault();
      const t0 = e.touches[0], t1 = e.touches[1];
      const openStartDist = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
      const cleanup = () => {
        productBox.removeEventListener('touchmove', onMove);
        productBox.removeEventListener('touchend', cleanup);
        productBox.removeEventListener('touchcancel', cleanup);
      };
      const onMove = (ev) => {
        if (ev.touches.length < 2) { cleanup(); return; }
        ev.preventDefault();
        const dist = Math.hypot(ev.touches[0].clientX - ev.touches[1].clientX, ev.touches[0].clientY - ev.touches[1].clientY);
        if (dist > openStartDist * 1.1) {
          cleanup();
          toggleBoxZoom();
        }
      };
      productBox.addEventListener('touchmove', onMove, { passive: false });
      productBox.addEventListener('touchend', cleanup, { once: true });
      productBox.addEventListener('touchcancel', cleanup, { once: true });
      return;
    }
    if (zoomed) return;
    let img = e.target.closest('img');
    if (img && img.closest('#product-box-default')) img = null;
    let fromPackshot = false;
    let pendingBoxSide = null;
    if (!img) {
      const boxSide = e.target.closest('#product-box-default .box-side[data-src], #product-box-default .box-side-2d[data-src]');
      if (!boxSide) return;
      img = document.querySelector('#product-box-3d-face-visual img');
      if (!img) return;
      fromPackshot = true;
      pendingBoxSide = boxSide;
    }
    e.preventDefault();
    const imgHolder = img.parentElement;
    translateX = translateY = 0;
    img.style.transformOrigin = '50% 50%';
    img.style.transform = 'scale(1)';
    img.classList.add('zoomed');
    zoomed = true;
    currentScale = 1;
    dragController = new AbortController();
    attachZoomedListeners(img, imgHolder, dragController.signal);
    pinchActive = true;
    dragging = false;
    img.classList.add('pinching');
    const t0 = e.touches[0], t1 = e.touches[1];
    const midX = (t0.clientX + t1.clientX) / 2;
    const midY = (t0.clientY + t1.clientY) / 2;
    pinchStartDist = Math.hypot(t0.clientX - t1.clientX, t0.clientY - t1.clientY);
    pinchLastDist = pinchStartDist;
    pinchStartScale = 1;
    prevPinchMidX = midX;
    prevPinchMidY = midY;
    const holderRect = imgHolder.getBoundingClientRect();
    pinchHolderNatLeft = holderRect.left;
    pinchHolderNatTop = holderRect.top;
    if (fromPackshot) {
      productBox.addEventListener('touchmove', (ev) => {
        if (ev.target.closest('#product-box-3d-face-visual') || !pinchActive || ev.touches.length !== 2) return;
        ev.preventDefault();
        const pt0 = ev.touches[0], pt1 = ev.touches[1];
        const dist = Math.hypot(pt0.clientX - pt1.clientX, pt0.clientY - pt1.clientY);
        if (pendingBoxSide) {
          pinchLastDist = dist;
          if (dist > pinchStartDist * 1.05) {
            show3DFaceOverlay(pendingBoxSide, null, false);
            pendingBoxSide = null;
            prevPinchMidX = (pt0.clientX + pt1.clientX) / 2;
            prevPinchMidY = (pt0.clientY + pt1.clientY) / 2;
          } else {
            return;
          }
        }
        const pmidX = (pt0.clientX + pt1.clientX) / 2;
        const pmidY = (pt0.clientY + pt1.clientY) / 2;
        const newScale = Math.min(zoomTargetSize() / img.offsetWidth, Math.max(1, pinchStartScale * (dist / pinchStartDist)));
        pinchLastDist = dist;
        translateX += pmidX - prevPinchMidX;
        translateY += pmidY - prevPinchMidY;
        prevPinchMidX = pmidX;
        prevPinchMidY = pmidY;
        const localX = pmidX - pinchHolderNatLeft - translateX;
        const localY = pmidY - pinchHolderNatTop - translateY;
        img.style.transformOrigin = `${(localX / img.offsetWidth) * 100}% ${(localY / img.offsetHeight) * 100}%`;
        img.style.transform = `scale(${newScale})`;
        imgHolder.style.transform = `translate(${translateX}px, ${translateY}px)`;
        currentScale = newScale;
        hasMoved = true;
      }, { signal: dragController.signal, passive: false });
      productBox.addEventListener('touchend', (ev) => {
        if (ev.target.closest('#product-box-3d-face-visual')) return;
        if (ev.touches.length < 2 && pinchActive) {
          pinchActive = false;
          img.classList.remove('pinching');
          hasMoved = true;
          if (currentScale <= 1) {
            exitZoomedState(img, imgHolder);
            zoomed = false;
            if (!pendingBoxSide) hide3DFaceOverlay();
            if (pinchStartScale === 1 && pinchLastDist < pinchStartDist * 0.8) toggleBoxZoom();
          }
        }
      }, { signal: dragController.signal });
    }
  }, { passive: false });

  new ProductBoxGallerySwipe(productBox);

  document.querySelectorAll('.product-dosageforms-packshot img').forEach((packshotImage) => {
    const markLoaded = () => packshotImage.closest('.product-dosageforms-packshot').classList.add('packshot-loaded');
    packshotImage.complete ? markLoaded() : packshotImage.addEventListener('load', markLoaded);
  });
});
